export const PROFILE_DATA = 'PROFILE_DATA'
export const AGENTS_DATA = 'AGENTS_DATA'
